export default "__VITE_ASSET__277e952f__"